// @ts-check

const createScript = id => {
    const $fragment = document.createDocumentFragment();

    const $script = document.createElement("script");

    $script.innerHTML = `
        (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
        m[i].l=1*new Date();k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
        (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

        ym(${id}, "init", {
            clickmap:true,
            trackLinks:true,
            accurateTrackBounce:true
        });
    `;

    const $pixel = document.createElement("noscript");

    $pixel.appendChild(document.createElement("div"));

    $pixel.firstElementChild.innerHTML = `<img src="https://mc.yandex.ru/watch/${id}" style="position:absolute; left:-9999px;" alt="" />`;

    $fragment.appendChild($script);
    $fragment.appendChild($pixel);

    return $fragment;
};

export default createScript;
